import { render, staticRenderFns } from "./ledger.vue?vue&type=template&id=54f4c064&scoped=true"
import script from "./ledger.vue?vue&type=script&lang=js"
export * from "./ledger.vue?vue&type=script&lang=js"
import style0 from "./ledger.vue?vue&type=style&index=0&id=54f4c064&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f4c064",
  null
  
)

export default component.exports